<template>
  <div>
    <el-button type="primary" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-drawer
        title="绑定操作"
        :visible.sync="openStatus"
        direction="rtl"
        size="90%"
        :append-to-body="true"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :wrapperClosable="false"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form label-width="120px">
              <el-form-item>
                <el-upload
                    ref="uploadBtn"
                    drag
                    action="/product/xlsxCreate"
                    name="file"
                    :data="param"
                    :auto-upload="false"
                    :limit="1"
                    :headers="headers"
                    @submit="toSubmit"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且按照导入模板格式</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="toSubmit">提交</el-button>
                <el-button @click="closeSee">取消</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-collapse v-model="collapseIndex">
              <el-collapse-item :title="'成功：' + success.length" name="success">
                <el-table :data="success" border style="width: 100%">
                  <el-table-column prop="name" label="名称"></el-table-column>
                  <el-table-column prop="model_code" label="存货编码"></el-table-column>
                </el-table>
              </el-collapse-item>
              <el-collapse-item :title="'失败：' + fault.length" name="fault">
                <el-table :data="fault" border style="width: 100%">
                  <el-table-column prop="name" label="名称"></el-table-column>
                  <el-table-column prop="model_code" label="存货编码"></el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
      headers: {},
      param: {},
      success: [],
      fault: [],
      collapseIndex: 'success'
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.openStatus = false;
      _this.$emit('finish', {});
    },
    toSubmit() {
      const _this = this;
      if (_this.$refs.uploadBtn.uploadFiles.length > 0) {
        const file = _this.$refs.uploadBtn.uploadFiles[0];
        const formData = new FormData();
        formData.append('file', file.raw)
        _this.submitIng = false;
        _this.$api.productXlsxCreate(formData)
            .then(res => {
              _this.submitIng = false;
              _this.success = res.success;
              _this.fault = res.fault;
              _this.$message.success('操作成功');
            })
            .catch(err => {
              _this.submitIng = false;
              _this.$message.error(err.msg);
            })
      } else {
        _this.$message.error('上传文件不能为空');
      }
    }
  },
};
</script>